import { MeteoType } from 'api/resort/types';
import { NextLink } from 'components/blocks/NextLink';

export const MeteoLogo = (
  { logo, className }: { logo: MeteoType, className: string },
) => {
  if (logo === MeteoType.meteoFrance) {
    return (
      <div className={className}>
        <NextLink href="https://meteofrance.com/" target="_blank">
          <img src="/assets/resort/meteo-france.png" alt="MeteoFrance" />
        </NextLink>
      </div>
    );
  }

  if (logo === MeteoType.whiteMountains) {
    return (
      <div className={className}>
        <NextLink href="https://www.met.no/" target="_blank">
          <img src="/assets/resort/provider-metno.png" alt="WhiteMountains" />
        </NextLink>
      </div>
    );
  }

  return <></>;
};
